module.exports = __webpack_public_path__ + "static/img/Boss_31082.1ff44287.png";